import { Group, Text } from '@mantine/core'
import { IconFolderFilled } from '@tabler/icons-react'
import { Camera } from '@/types/camera'
import { Deployment, InputSourceType } from '@/types/deployment'
import { CameraCell } from './CameraCell'

type DeploymentInputSourceProps = {
  deployment: Deployment
  camera: Camera | null
  deviceActive: boolean
}

export const DeploymentInputSource = ({
  deployment,
  camera,
  deviceActive
}: DeploymentInputSourceProps) => {
  if (!deployment.settings_payload) {
    return null
  }

  if (
    deployment.settings_payload.input_source_type ===
    InputSourceType.MediaFolder
  ) {
    return (
      <Group gap="xs" wrap="nowrap">
        <IconFolderFilled size={16} color="var(--mantine-color-yellow-6)" />
        <Text
          size="sm"
          maw={240}
          title={deployment.settings_payload.input_folder_path}
          truncate
        >
          {deployment.settings_payload.input_folder_path}
        </Text>
      </Group>
    )
  }

  if (!camera) {
    return null
  }

  return <CameraCell camera={camera} deviceActive={deviceActive} />
}
